import scrollerSponsors from '../widgets/scrollerSponsors.js';
import customTicketButton from '../widgets/customTicketButton.js';
import mainSlideshow from '../widgets/mainSlideshow.js';
import hotButtons from '../../js/widgets/hotButtons.js';
import { isPage, moveWidgetsBeforeContent } from '../utils/helpers.js';

export default function initRodeoWidgets() {
  const rodeoSubpage = themeData.find((theme) => theme.classBody === 'gnfa-rodeo');

  customTicketButton();
  if (isPage('gnfa-rodeo-landing')) {
    scrollerSponsors('scroller-sponsors-rodeo', scrollerSponsorsRodeoOpts, 6);
    mainSlideshow('rodeoSlideshow', rodeoSlideshowOpts);
    hotButtons('rodeoHotButtons', rodeoHotButtonsOpts, 6);
    moveWidgetsBeforeContent(rodeoSubpage.widgetContainer);
  }
}
